/* eslint-disable */
/* general styles */
import './general/scss/index.scss';

/* stuff and polyfills */
import './general/js/lazysizes';

/* components */
import './components/lazysizes';

/* legacy */
import './legacy/js/vendors/jquery.min.js';
import 'bootstrap';
import 'jquery-validation';
import 'jquery-ajax-unobtrusive';
import './legacy/js/vendors/jquery.responsive-tables.min.js';
import './legacy/js/vendors/jquery.cookie.min.js';
import 'tether';
import 'popper.js';
import './legacy/js/vendors/slick.min.js';

import './legacy/js/vendors/_/modernizr-custom.js';
import './legacy/js/vendors/_/jquery.alphanum.min.js';
import './legacy/js/vendors/_/jquery.icheck.min.js';
import './legacy/js/vendors/_/bootstrap-inputmask.js';

import 'dropzone';
import './legacy/js/vendors/_/lightgallery.min.js';
import './legacy/js/vendors/_/lg-thumbnail.min.js';
import './legacy/js/_/passStrength';

/* MasterSearch specific js files */
import './legacy/js/vendors/_/markerclusterer.min.js';
import './legacy/js/vendors/_/Bubble.js';
import './legacy/js/vendors/_/jquery.grumble.js';
import './legacy/js/vendors/_/jquery.geolocation.js';
import './legacy/js/vendors/_/jquery.scrollTo-1.4.3.1-min.js';

import './legacy/js/_/site-global-variables.js';
import './legacy/js/_/site-functions.js';
import './legacy/js/_/site.js';

import './legacy/js/vendors/jquery-ui.min.js';
import './legacy/js/vendors/_/jquery.ui.touch-punch.min.js';
import './legacy/js/_/googleMap/google-maps';

/* MasterSearch specific css files */
import './legacy/css/grumble.css';

import './legacy/js/app';
import './legacy/js/modules/carousel';
import './legacy/js/modules/functions';
import './legacy/js/modules/sliders';
import './legacy/js/modules/tabs';

/* require svg */
const files = require.context('./general/svg', true, /^\.\/.*\.svg/);
files.keys().forEach(files);

window.unipolSharedNamespace.gtmTracking();
